import React, { useState } from 'react';
import { Form, Button } from "antd";
import { useTranslation } from 'react-i18next';
import ResponsiveModal from '../../Shared/ResponsiveModal/ResponsiveModal';
import CredentialForm from '../CredentialForm/CredentialForm';

const AddCredentialModal = ({ onCancel, onCreate, onUpdate, isEdit = false, credential = null, loading = false }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            let success;
            if (isEdit && onUpdate && credential) {
                success = await onUpdate(credential.id, values);
            } else if (onCreate) {
                success = await onCreate(values, form);
            }

            if (success) {
                form.resetFields();
                onCancel();
            }
        } catch (error) {
            // Validation error, do nothing
            console.error('Validation failed:', error);
        }
    };

    return (
        <ResponsiveModal
            title={isEdit ? t('edit_credential') : t('add_credential')}
            open
            onCancel={onCancel}
            desktopWidth={600}
            footer={
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button onClick={onCancel}>
                        {t('cancel')}
                    </Button>
                    <Button
                        type="primary"
                        onClick={handleSubmit}
                        loading={loading}
                    >
                        {isEdit ? t('save') : t('add')}
                    </Button>
                </div>
            }
        >
            <CredentialForm form={form} isEdit={isEdit} initialValues={credential} />
        </ResponsiveModal>
    );
};

export default AddCredentialModal;
